import React from "react";
import "../../styles/SummaryCards.css";

const SummaryCards = ({ data = [] }) => {
  if (!Array.isArray(data)) {
    console.error("Erro: 'data' não é um array em SummaryCards.jsx", data);
    return <p>Erro ao carregar dados.</p>;
  }

  return (
    <div className="summary-cards">
      {data.map((item, index) => (
        <div className="card" key={index}>
          <div className="card-icon">{item.icon}</div>
          <div className="card-details">
            <h3>{item.title}</h3>
            <p>
              {item.realizadas || item.resolvidas}/{item.esperadas || item.total} ({item.percentual}%)
            </p>
            {/* Adicionando as 3 últimas informações */}
            {item.ultimosRegistros && (
              <ul className="card-history">
                {item.ultimosRegistros.slice(-3).map((registro, i) => (
                  <li key={i}>{registro}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
